import { createTheme } from '@mui/material';

import { Colors } from './Variables';

declare module '@mui/material/Button' {
    interface ButtonPropsVariantOverrides {
        jp_crm: true;
        'outlined-secondary': true;
    }
}

export const jpCRM = createTheme({
    typography: {
        fontFamily: [`'AkkuratLLTT'`, `sans-serif`].join(',')
    },
    components: {
        MuiButton: {
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        textTransform: 'none',
                        backgroundColor: Colors.blueLink,
                        minWidth: '122px'
                    }
                },
                {
                    props: { variant: 'outlined' },
                    style: {
                        textTransform: 'none',
                        border: `solid 2px ${Colors.blueLink}`,
                        color: Colors.blueLink,
                        transition: 'all .5s ease',
                        '&:hover': {
                            borderWidth: '2px',
                            color: '#1976d2'
                        }
                    }
                },
                {
                    props: { variant: 'outlined-secondary' },
                    style: {
                        textTransform: 'none',
                        border: `solid 2px ${Colors.secondaryButton}`,
                        color: Colors.secondaryButtonText,
                        background: Colors.white,
                        transition: 'all .5s ease',
                        borderRadius: '6px',
                        boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.15)',
                        fontSize: '13px',
                        '&:hover': {
                            borderWidth: '2px',
                            color: Colors.secondaryButtonText
                        }
                    }
                }
            ]
        }
    }
});
